import React from 'react';
import Icon from './Icon';
import ActivityRow from './ActivityRow';
import EmptyState from './EmptyState';

export default function SelectedDayPanel({ selectedLabel, selectedDayItems, openAddForDay, openDetail, selectedDay }) {
  return (
    <div className="card cardFill">
      <div className="cardTop">
        <div>
          <div className="cardTitle">Selected Day</div>
          <div className="cardSub">{selectedLabel} • {selectedDayItems.length} items</div>
        </div>
        <button type="button" className="ghost" onClick={() => openAddForDay(selectedDay)} aria-label="Add activity"><Icon name="plus" /><span>Add</span></button>
      </div>
      {selectedDayItems.length === 0 ? (
        <EmptyState title="Nothing here" subtitle="Add a task, or simulate system logs." />
      ) : (
        <div className="listScrollWrap">
          <div className="list">
            {selectedDayItems.map((a) => (
              <ActivityRow key={a.id} a={a} onView={openDetail} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
